export const ValidationWorkFlow = {
    path: '/validation_work_flows',
    name: 'validation_work_flows',
    component: () => import('@/views/Absence/ValidationWorkFlow/ValidationWorkFlows.vue'),
    children: [
        {
            path: '/validation_work_flows/add',
            name: 'validation_work_flows.add',
            component: () => import('@/views/Absence/ValidationWorkFlow/Form/ValidationWorkFlowForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/validation_work_flows/edit/:id',
            name: 'validation_work_flows.edit',
            component: () => import('@/views/Absence/ValidationWorkFlow/Form/ValidationWorkFlowForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/validation_work_flows/delete/:id',
            name: 'validation_work_flows.delete',
            component: () => import('@/views/Absence/ValidationWorkFlow/Form/ValidationWorkFlowForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/validation_work_flows/view/:id',
            name: 'validation_work_flows.view',
            component: () => import('@/views/Absence/ValidationWorkFlow/Form/ValidationWorkFlowForm.vue'),
            props: {viewAction: true}
        },
    ]
}

export const ValidationWorkFlowConfiguration = {
    path: '/validation_work_flows_configuration',
    name: 'validation_work_flows_configuration',
    component: () => import('@/views/Absence/ValidationWorkFlow/Form/ValidationWorkFlowConfiguration.vue'),
}